import brand from '@helpers/brand';
import { h6, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { ButtonStyles } from '../../Buttons/GeneralButton/Button.styles';
import { until, Device, from } from '@helpers/media';
import { fluidAdjusted } from '@helpers/fluid';
const Container = styled.div `
  border: 4px solid ${brand.buff.buff4};
  border-radius: 16px;
  padding: 32px;
  position: relative;
  overflow: hidden;
`;
const HexagonBackground = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  height: 200%;
  aspect-ratio: 1 / 1;
  z-index: -1;
  color: ${brand.buff.buff4};
  opacity: 0.15;
  transform: translate(55%, 10%);
`;
const Layout = styled.div `
  display: grid;
  gap: ${fluidAdjusted(16, 32, Device.Mobile, Device.ActualDesktop)};
  height: 100%;

  @media ${until(Device.TabletLarge)} {
    grid-template-rows: 50px 1fr;
  }
  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 46px 1fr;
  }
`;
const Icon = styled.div `
  display: flex;
  align-items: flex-start;
  color: ${brand.secondary.red5};

  @media ${until(Device.TabletLarge)} {
    svg {
      height: 100%;
    }
  }
  @media ${from(Device.TabletLarge)} {
    svg {
      width: 100%;
    }
  }
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: 13px;

  ${() => ButtonStyles.ButtonInner} {
    --textColour: ${brand.black};
  }
`;
const Title = styled.div `
  ${h6}
  margin: 0;
  font-weight: 900;
`;
const Summary = styled.div `
  ${paragraphSmall}
  font-weight: 100;
  margin: 0;
  margin-bottom: 15px;
`;
const ButtonWrapper = styled.div `
  margin-top: auto;
`;
export const DownloadCardStyles = {
    Container,
    Layout,
    Icon,
    Content,
    Title,
    Summary,
    HexagonBackground,
    ButtonWrapper,
};
